/* A/B: sale badge pill format - percent vs dollars (LDS test for BFCM).
   Sticky 50/50 assignment; server renders dollar-primary (it cannot know the
   visitor), this normalizes every badge to the assigned form and stamps the
   variant on the cart so orders carry it. Remove this file + its theme.liquid
   mount + the __abBadgePill consult in theme.js updatePrice to end the test. */
(function () {
  var KEY = 'wooj_ab_badge_pill';
  var variant;
  try {
    variant = localStorage.getItem(KEY);
    if (variant !== 'percent' && variant !== 'dollar') {
      variant = Math.random() < 0.5 ? 'percent' : 'dollar';
      localStorage.setItem(KEY, variant);
    }
  } catch (e) {
    variant = 'dollar'; // storage blocked: control group, no attribute stamped
  }
  window.__abBadgePill = variant;

  function money(cents) {
    if (window.theme && theme.Shopify && theme.Shopify.formatMoney) {
      return theme.Shopify.formatMoney(cents, theme.money_format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function normalize(root) {
    var wraps = (root || document).querySelectorAll('.auto-discount-price[data-auto-discount="true"]');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      var badge = w.querySelector('.auto-discount-badge');
      if (!badge) continue;
      var pct = parseInt(w.getAttribute('data-auto-discount-percentage'), 10) || 0;
      var orig = parseInt(w.getAttribute('data-original-price'), 10) || 0;
      var disc = parseInt(w.getAttribute('data-discounted-price'), 10) || 0;
      if (variant === 'percent' && pct > 0) {
        var pctText = pct + '% OFF';
        if (badge.textContent !== pctText) badge.textContent = pctText;
        badge.classList.remove('auto-discount-badge--savings');
      } else if (variant === 'dollar' && orig - disc > 0) {
        var usdText = 'Save ' + money(orig - disc);
        if (badge.textContent !== usdText) badge.textContent = usdText;
        badge.classList.add('auto-discount-badge--savings');
      }
    }
  }

  // Stamp the arm on the cart so the order carries it. Verified, not fire-and-
  // forget: on a first visit there is no cart yet, so this write and another
  // attribute writer (Intelligems' igId lands ~50-100ms later) each create a
  // cart and the last cookie wins - the stamp was lost for ~30% of web orders
  // (9/3 audit: every unstamped order still carried igId/_offer). So: write,
  // re-read cart.js, retry with backoff, and re-check after cart mutations.
  var stampAttempts = 0;
  var stampTimer = null;
  function stampCart(delayMs) {
    if (stampTimer) return;
    stampTimer = setTimeout(function () {
      stampTimer = null;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        if (cart && cart.attributes && cart.attributes._ab_badge_pill === variant) {
          try { sessionStorage.setItem(KEY + '_stamped', variant); } catch (e) {}
          return;
        }
        if (stampAttempts >= 5) return;
        stampAttempts++;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _ab_badge_pill: variant } }),
        }).then(function () { stampCart(2500 * stampAttempts); }); // verify on the next pass; backoff 2.5s, 5s, 7.5s ...
      }).catch(function () {});
    }, delayMs || 0);
  }

  var exposureSent = false;
  function sendExposure() {
    if (exposureSent) return;
    exposureSent = true;
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'ab_badge_pill', ab_badge_pill: variant });
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      normalize(document);
    });
  }

  function start() {
    normalize(document);
    sendExposure();
    stampCart(1500); // let the other first-load writers create the cart first
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('cc-variant-updated', schedule);
    // any cart mutation may have replaced the cart: re-verify the stamp
    ['cart:add', 'cart:open', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, function () { stampAttempts = 0; stampCart(1200); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
